import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import ContractSelect from "features/contracts/components/ContractSelect";
import { Customer_ContractDropdown } from "data/endpoints";
import DataQuery from "data/DataQuery";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { useQuery } from "data/hooks/useQuery";
import ContractDropdownDTO from "features/contracts/dtos/ContractDropdownDTO";
import {
  getSelectFieldOptions,
  getSelectFieldOptionKey,
  getTranslatedText,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import { useTranslation } from "react-i18next";

const ContractSelectField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const { bindReactSelectField, errors } = { ...formHandler };

  // store
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // fetch data
  let contractsQuery: DataQuery = {
    url: Customer_ContractDropdown,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: descriptor.options?.queryString
      ? new URLSearchParams(descriptor.options?.queryString)
      : undefined,
  };
  const { data: contracts } = useQuery<ContractDropdownDTO[]>(
    contractsQuery,
    [],
    [],
    { useTracker: true },
    { apply: true, condition: () => descriptor.options?.source === "fetch" }
  );

  // render
  return (
    <div className={descriptor.className}>
      <ContractSelect
        contracts={getSelectFieldOptions(descriptor, contracts)}
        label={getTranslatedText(descriptor, "label", t)}
        placeholder={getTranslatedText(descriptor, "placeholder", t)}
        {...bindReactSelectField(
          descriptor.name,
          getSelectFieldOptionKey(descriptor.options?.optionValue, "contractId")
        )}
        errors={errors}
      />
    </div>
  );
};

export default ContractSelectField;
